import React, { useState } from 'react';
import ApplicationFooter from '@/components/PrivateLayout/ApplicationFooter';
import { TabContentWrapper } from '@/components/_common';
import { Checkbox, Col, Descriptions, Divider, Layout, Row } from 'antd';

import { Helmet } from 'react-helmet';

import logo from '@/assets/images/Logo_Footer.png';
import logoMin from '@/assets/images/Logo-UC-mobile.png';
import { useWindowSize } from '@/hooks';
import { useRouteMatch } from 'react-router-dom';

import { useWorkOrderByGuid } from '@/core/domain/workorder/QRCode/QRCode.hooks';
import { applyMask } from '@/utils/mask';
import WorkOrderViewPublicListParts from '@/components/Movements/WorkOrders/WorkOrderQRCode/WorkOrderViewPublicListParts';
import WorkOrderViewPublicListTasks from '@/components/Movements/WorkOrders/WorkOrderQRCode/WorkOrderViewPublicListTasks';
import { isAppPortocar } from '@/index';

function WorkOrderViewPublicPage() {
  const { isMobile } = useWindowSize();
  const { guid } = useRouteMatch<{ guid: string }>().params;

  const { data } = useWorkOrderByGuid(guid);

  const complement = data?.complements?.find(
    (complement) => complement.workOrderGuid === guid,
  );

  const maskLicensePlate = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  const [removeImage, setRemoveImage] = useState(false);

  return (
    <>
      <Helmet title={'Ordem de serviço'} />

      <Layout.Header className="app-header">
        <div className="app-header-content" style={{ maxWidth: '100%' }}>
          {isMobile ? (
            <div className="logoMin">
              <img
                className="image"
                src={
                  isAppPortocar
                    ? '/images/Logo_PortoCar_branca-icon.svg'
                    : logoMin
                }
                alt="logo"
                style={{ width: '60px' }}
              />
            </div>
          ) : (
            <div className="logo">
              <img
                className="image"
                src={isAppPortocar ? '/images/Logo_PortoCar_branca.svg' : logo}
                alt="logo"
              />
            </div>
          )}
        </div>
      </Layout.Header>

      <div style={{ marginTop: '90px', marginBottom: '90px' }}>
        <TabContentWrapper
          title={'workOrders.public.workOrder.view'}
          permissions={[]}
          // extra={
          //   // <SpaceForButton>
          //   //   <Button block type="primary">
          //   //     Adicionar complemento
          //   //   </Button>
          //   // </SpaceForButton>
          // }
          isQRCode
        >
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <Descriptions
                bordered
                size="small"
                layout="vertical"
                column={{ xxl: 3, xl: 3, lg: 3, md: 3, sm: 1, xs: 1 }}
                title="Dados do Orçamento"
                labelStyle={{ fontWeight: 'bold' }}
              >
                <Descriptions.Item label="Orçamento">
                  {complement?.complementIdentifier ?? '-'}
                </Descriptions.Item>

                <Descriptions.Item label="Placa">
                  {applyMask(data?.vehicle?.licensePlate, maskLicensePlate)}
                </Descriptions.Item>

                <Descriptions.Item label="Veículo">
                  {data?.vehicle?.model ?? '-'}
                </Descriptions.Item>
              </Descriptions>
            </Col>

            <Col span={24}>
              <strong>
                <Checkbox onChange={(e) => setRemoveImage(e.target.checked)}>
                  Exibição simplificada
                </Checkbox>
              </strong>
            </Col>

            <Col span={24}>
              <WorkOrderViewPublicListParts
                data={data}
                removeImage={removeImage}
              />

              <Divider />

              <WorkOrderViewPublicListTasks data={data} />
            </Col>
          </Row>
        </TabContentWrapper>
      </div>

      <ApplicationFooter />
    </>
  );
}

export default WorkOrderViewPublicPage;
